import axios from "axios";
import { Dispatch } from "redux";
import Url from "../../../Url";
import { PatientListActionTypes } from "./ActionTypes";
import { PatientDetailsResponse } from "./Model";
import {
  PatientListAPIResClearAction,
  PatientListErrorAction,
  PatientListLoadingAction,
  PatientListSuccessAction,
  PatientListAPIMsgAction,
} from "./Action";
import { headers } from "../../../components/Utility";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";

let apiRes = {} as PatientDetailsResponse;
export const getPatientListValue = () => {
  return function (dispatch: Dispatch<PatientListActionTypes>) {
    dispatch(PatientListLoadingAction(true));
    setupInterceptorsTo(axios)
      .get(Url.baseUrl + `/patientapp/api/patient/patient_list`, {
        headers: headers,
      })
      .then((res) => {
        apiRes = res.data;
        dispatch(PatientListLoadingAction(false));
        dispatch(
          PatientListSuccessAction(
            res.data,
            res.data.message !== undefined
              ? res.data.message
              : "Patient list fetch successfully."
          )
        );
      })
      .catch((error) => {
        dispatch(PatientListLoadingAction(false));
        dispatch(
          PatientListErrorAction(
            {} as PatientDetailsResponse,
            error.response.data !== undefined
              ? error.response.data.message !== undefined
                ? error.response.data.message
                : "Something went wrong"
              : "Something went wrong",
            error.status !== undefined ? error.response.data.status || 0 : 0
          )
        );
      });
  };
};

export const PatientListAPIResMsg = () => {
  return function (dispatch: Dispatch<PatientListActionTypes>) {
    dispatch(PatientListAPIMsgAction(apiRes as PatientDetailsResponse, "", "", 0));
  };
};

export const clearPatientListAPIRes = () => {
  return function (dispatch: Dispatch<PatientListActionTypes>) {
    dispatch(PatientListAPIResClearAction({} as PatientDetailsResponse, "", "", 0));
  };
};
